var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVehicleInspection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    fillOpacity: 0.3,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5078 8.3304C13.5078 12.7721 6.84115 12.7721 6.84115 8.3304H8.50781C8.50781 10.5554 11.8411 10.5554 11.8411 8.3304M16.8411 15.8304V18.3304H3.50781V15.8304C3.50781 13.6054 7.94948 12.4971 10.1745 12.4971C12.3995 12.4971 16.8411 13.6054 16.8411 15.8304ZM15.2578 15.8304C15.2578 15.2971 12.6495 14.0804 10.1745 14.0804C7.69948 14.0804 5.09115 15.2971 5.09115 15.8304V16.7471H15.2578M10.5911 2.49707C10.8245 2.49707 11.0078 2.6804 11.0078 2.91374V5.41374H11.8411V3.3304C12.4309 3.60334 12.925 4.04723 13.2594 4.60447C13.5937 5.16172 13.7529 5.80659 13.7161 6.4554C13.7161 6.4554 14.2995 6.57207 14.3411 7.49707H6.00781C6.00781 6.57207 6.63281 6.4554 6.63281 6.4554C6.59611 5.80659 6.75525 5.16172 7.0896 4.60447C7.42394 4.04723 7.91806 3.60334 8.50781 3.3304V5.41374H9.34115V2.91374C9.34115 2.6804 9.52448 2.49707 9.75781 2.49707",
    fill: "#9C4900",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleInspection);
export default __webpack_public_path__ + "static/media/VehicleInspection.2de0311f7b39ce12a64ecb9ca057c5f6.svg";
export { ForwardRef as ReactComponent };